import { abschnitt, ersetze, h, knopf, meldung, schritte, setzeMeldung } from '../dom.js';
import { aktuelleSerie, arbeite, ereignisse, erzeugungsStand, starteSerie } from '../foto-warteschlange.js';
import { fehlerText } from '../api.js';
import type { Ansicht } from '../router.js';
import { groesseText } from '../zeit.js';
import { Aufraeumer, kopf, pruefpunktStand } from './gemeinsam.js';

export const fotos: Ansicht = async (ziel) => {
  const aufraeumer = new Aufraeumer();
  const status = meldung();
  const stand = h('div', {});
  const anzahl = h('select', { id: 'foto-anzahl', name: 'foto-anzahl' }, ...[20, 50, 100].map((n) => h('option', { value: n, selected: n === 20 }, `${n} Fotos`)));
  const bremse = h('input', { type: 'checkbox', id: 'foto-bremse', name: 'foto-bremse', checked: true });
  const startKnopf = knopf('Fotos erzeugen und hochladen', async () => {
    startKnopf.disabled = true;
    try {
      await starteSerie(Number(anzahl.value), bremse.checked);
      setzeMeldung(status, 'Hochladen läuft. Jetzt, mitten im Hochladen, die App ganz schließen und wieder öffnen.', 'info');
    } catch (fehler) {
      setzeMeldung(status, fehlerText(fehler), 'fehler');
    } finally {
      await zeichne();
    }
  });

  async function zeichne(): Promise<void> {
    const erzeugung = erzeugungsStand();
    const s = await aktuelleSerie();
    const laeuft = erzeugung.anzahl > 0 || s?.serie.status === 'laeuft' || s?.serie.status === 'erzeugen';
    startKnopf.disabled = laeuft;
    if (erzeugung.anzahl > 0) {
      ersetze(stand, h('p', {}, `Foto ${erzeugung.nr} von ${erzeugung.anzahl} wird erzeugt …`), h('progress', { max: erzeugung.anzahl, value: erzeugung.nr, 'aria-label': 'Fotos erzeugen' }));
      return;
    }
    if (!s) {
      ersetze(stand, h('p', { class: 'leise' }, 'Noch keine Serie.'));
      return;
    }
    const statusText = { erzeugen: 'wird erzeugt', laeuft: 'Hochladen läuft', fertig: 'fertig', abgebrochen: 'beim Erzeugen abgebrochen' }[s.serie.status];
    ersetze(
      stand,
      h('p', {}, `Letzte Serie: ${s.serie.anzahl} Fotos, ${groesseText(s.bytes)}, ${statusText}.`),
      h('progress', { max: s.serie.anzahl, value: s.gesendet, 'aria-label': 'Fotos gesendet' }),
      h('p', {}, `${s.gesendet} gesendet, ${s.wartend} warten${s.fehler ? `, ${s.fehler} mit Fehler` : ''}.`),
      s.serie.unterbrechungen.length > 0 &&
        h('p', {}, `Unterbrochen: ${s.serie.unterbrechungen.map((u) => `nach ${u.gesendet} Fotos`).join(', ')}.`),
      s.serie.status === 'laeuft' && knopf('Weiter hochladen', () => arbeite(), 'sekundaer'),
    );
  }

  aufraeumer.hoere(ereignisse, 'fortschritt', () => void zeichne());

  ziel.append(
    ...kopf('Foto-Warteschlange', 'Überlebt die Warteschlange, wenn die App mitten im Hochladen geschlossen wird? Am Ende müssen genau alle Fotos ankommen, keines doppelt.'),
    abschnitt(
      'So geht der Test',
      schritte(
        'Anzahl wählen und „Fotos erzeugen und hochladen“ tippen. Die Testfotos entstehen in der App (2048\u00a0Pixel, etwa 0,3–0,5\u00a0MB).',
        'Das Hochladen ist gebremst (etwa 1,5\u00a0Sekunden je Foto). Nach einigen Fotos die App ganz schließen.',
        'App wieder öffnen: Das Hochladen geht von selbst weiter.',
        'Am Ende gleicht die App mit dem Server ab und zeigt das Ergebnis.',
      ),
    ),
    abschnitt(
      'Test',
      pruefpunktStand('foto-warteschlange', aufraeumer),
      h('div', { class: 'feld' }, h('label', { for: 'foto-anzahl' }, 'Anzahl'), anzahl),
      h('label', { class: 'auswahl' }, bremse, 'Hochladen bremsen (für den Test empfohlen)'),
      startKnopf,
      status,
      stand,
    ),
  );
  await zeichne();
  return aufraeumer.alles;
};
